import type { ExperimentStatus } from '../types/experiment.types';

export const DateRange = {
  LAST_7_DAYS: 'last_7_days',
  LAST_30_DAYS: 'last_30_days',
  LAST_90_DAYS: 'last_90_days',
  ALL_TIME: 'all_time',
} as const;

export type DateRange = (typeof DateRange)[keyof typeof DateRange];

export interface ExperimentFilters {
  statuses: ExperimentStatus[];
  dateRange: DateRange;
}

// Frozen (object + the `statuses` array) so this shared module-level default
// can't be mutated in place — every filter write builds a new object, so an
// accidental `DEFAULT_FILTERS.statuses.push(...)` would otherwise corrupt every
// reader. Freezing turns that into a throw in strict mode.
const DEFAULT_STATUSES: ExperimentStatus[] = [];
Object.freeze(DEFAULT_STATUSES);

export const DEFAULT_FILTERS: ExperimentFilters = Object.freeze({
  statuses: DEFAULT_STATUSES,
  // Default to All Time now that the date filter is functional: a narrower
  // default would hide experiments created outside the window — they run ~28+7
  // days, so a 30-day default would drop running + completed ones from view.
  dateRange: DateRange.ALL_TIME,
});
